var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWhiteLinkLeft = function SvgWhiteLinkLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2127 5.20756C19.6631 -0.512652 4.38643 1.13904 2.18762 13.006C-0.0111818 24.8729 12.6303 29.2929 19.333 28.7656C34.1489 27.5905 29.8177 12.2741 24.2127 5.20756Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1365 18.3409L9.04553 15.2499M9.04553 15.2499L12.1365 12.1589M9.04553 15.2499L22.9551 15.2499",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgWhiteLinkLeft;